import ScrollHint from "scroll-hint";

const SELECTORS = [
  ".wp-block-table.has-scroll-hint",
  ".wp-block-group.has-scroll-hint",
];
const SELECTOR = SELECTORS.join(", ");
const DATA_KEY = "scrollHintBound";
const MEDIA_QUERY = "(max-width: 767px)";

let bootstrapped = false;

const bindScrollHint = (element) => {
  if (element.dataset[DATA_KEY] === "true") {
    return;
  }

  element.dataset[DATA_KEY] = "true";

  new ScrollHint(element, {
    remainingTime: 2500,
    suggestiveShadow: true,
    i18n: {
      scrollable: "横にスクロールできます",
    },
  });
};

const hydrate = (mediaQuery) => {
  if (mediaQuery && !mediaQuery.matches) {
    return;
  }

  const targets = document.querySelectorAll(SELECTOR);
  if (!targets.length) {
    return;
  }

  targets.forEach((target) => bindScrollHint(target));
};

const start = () => {
  const mediaQuery = window.matchMedia ? window.matchMedia(MEDIA_QUERY) : null;

  const rerun = () => hydrate(mediaQuery);

  rerun();

  if (mediaQuery) {
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", rerun);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(rerun);
    }
  }

  if (typeof MutationObserver !== "undefined") {
    const observer = new MutationObserver(rerun);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
};

export const initTableScrollHint = () => {
  if (bootstrapped) {
    return;
  }

  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  const launch = () => {
    if (bootstrapped) {
      return;
    }
    bootstrapped = true;
    start();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", launch, { once: true });
  } else {
    launch();
  }
};
